<template>
  <section class="swiper-medias__wrap">
    <Swiper
      ref="swiper-medias"
      key="swiper-medias"
      :slides-per-view="mq.mdPlus ? 2.5 : 1.1"
      :modules="swiper.modules"
      :pagination="swiper.pagination"
      :space-between="16"
      class="swiper-medias swiper3"
    >
      <SwiperSlide
        v-for="(media, key) in medias"
        :key="`media-${key}`"
        class="swiper-medias__image"
        :style="{
          backgroundImage: `url(${media.md || 'https://placehold.co/600x300'})`,
        }"
      >
      </SwiperSlide>

      <SwiperSlide v-if="mq.mdPlus" class="swiper-medias__image" />

      <SectionSwiperControls :items-count="medias.length" :min-items="mq.mdPlus ? 2 : 1" larger />
    </Swiper>
  </section>
</template>

<script>
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import SectionSwiperControls from '@/components/blocks/SectionSwiperControls.vue'

export default {
  name: 'SectionSwiperMedias',

  components: {
    SectionSwiperControls,
    Swiper,
    SwiperSlide,
  },

  inject: ['mq'],

  props: {
    medias: {
      type: Array,
    },
  },

  data() {
    return {
      swiper: {
        modules: [Pagination],
        slideToClickedSlide: true,
        grabCursor: true,

        pagination: {
          clickable: true,
          horizontalClass: 'swipe-horizontal__medias',
          bulletClass: 'swipe-bullet -blue',
          bulletActiveClass: 'swipe-bullet-active-blue',
        },
      },
    }
  },
}
</script>
